import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    root: {
        width: "100%",
        border: "1px solid #DBDBDB",
        borderRadius: "5px",
        marginBottom: "16px",
    },
    container: {
        padding: "16px",
    },
    right_side: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        margin: "auto 0",
        paddingRight: "16px",
    },
    body: {
        fontSize: "16px",
    },
}));
